export default {"src":"/_next/static/media/building-columns-classic-solid.c3a87590.svg","height":24,"width":24};